module.exports = __webpack_public_path__ + "528cccfabae3796f29543dbf80155b6d.pdf";